export const QUESTION_BANK_STATION_IDS_BY_ISLAND_SLUG: Record<
  string,
  string[]
> = {
  "welcome-cove": ["station_1"],
  "welcome-cove-ii": ["station_2"],
  "prompt-peninsula": ["station_3"],
  "automation-atoll": ["station_4"],
  "ethics-isle": ["station_5"],
  "collaboration-coral": ["station_6"],
};

export interface QuestionBankStationRouteLike {
  id?: string | null;
  slug?: string | null;
  source_station_id?: string | null;
}

const CREW_ISLAND_SUFFIX_PATTERN = /-[0-9a-f]{8}$/i;

function normalizeStationRouteKey(value?: string | null) {
  return value?.trim().toLowerCase().replace(/-/g, "_") ?? "";
}

export function getBaseQuestionBankIslandSlug(slug: string) {
  return slug.replace(CREW_ISLAND_SUFFIX_PATTERN, "");
}

export function getQuestionBankStationIdsForIsland(slug: string) {
  return (
    QUESTION_BANK_STATION_IDS_BY_ISLAND_SLUG[
      getBaseQuestionBankIslandSlug(slug)
    ] ?? null
  );
}

export function isQuestionBankStationForIsland(
  slug: string,
  station: QuestionBankStationRouteLike,
) {
  const stationIds = getQuestionBankStationIdsForIsland(slug);
  if (!stationIds) return true;

  const allowedKeys = new Set(stationIds.map(normalizeStationRouteKey));
  return [station.source_station_id, station.slug, station.id]
    .map(normalizeStationRouteKey)
    .some((stationKey) => stationKey && allowedKeys.has(stationKey));
}

export function questionBankStationOrderIndex(
  slug: string,
  station: QuestionBankStationRouteLike,
) {
  const stationIds = getQuestionBankStationIdsForIsland(slug);
  if (!stationIds) return -1;

  const stationKeys = [station.source_station_id, station.slug, station.id].map(
    normalizeStationRouteKey,
  );
  return stationIds.findIndex((stationId) =>
    stationKeys.includes(normalizeStationRouteKey(stationId)),
  );
}
